import { render } from "./ContactLinkedCompanies.vue?vue&type=template&id=d744fb70&scoped=true"
import script from "./ContactLinkedCompanies.vue?vue&type=script&lang=js"
export * from "./ContactLinkedCompanies.vue?vue&type=script&lang=js"

import "./ContactLinkedCompanies.vue?vue&type=style&index=0&id=d744fb70&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d744fb70"]])

export default __exports__